<template>
    <v-navigation-drawer
      :mini-variant="closed"
      :expand-on-hover="$vuetify.breakpoint.lgAndUp"
      :clipped="true"
      :mobile-breakpoint="0"
      app
      dark
      color="#1F1F1F"
      id="app-side-bar"
    >
      <v-list rounded dark nav dense>
        <v-list-item link id="projects-tab" :to="{name: 'ProjectsPage'}">
          <v-list-item-icon>
            <svg-icon type="mdi" :path="mdiFolderMultiplePath"></svg-icon>
          </v-list-item-icon>
          <v-list-item-title>Projects</v-list-item-title>
        </v-list-item>
          <v-list-item link id="compounds-tab" :to="{name: 'CompoundsPage'}">
              <v-list-item-icon>
                <svg-icon type="mdi" :path="mdiHexagonMultiplePath"></svg-icon>
              </v-list-item-icon>
              <v-list-item-title>Compounds</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isDAM" link id="data-access-manager-tab" :to="{name: 'DataAccessManagerPage'}">
              <v-list-item-icon>
                <svg-icon type="mdi" :path="mdiCloudKeyOutlinePath"></svg-icon>
              </v-list-item-icon>
              <v-list-item-title>Data Access Manager</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
</template>

<!-- To do: authenticate user to see if they have data access manager role. If yes, show data access manager tab -->
<script>
import * as api from '@/js/utils/api.js';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCloudKeyOutline } from '@mdi/js';
import { mdiHexagonMultiple } from '@mdi/js';
import { mdiFolderMultiple } from '@mdi/js';

    export default {
      name: 'AppSidebar',
      props:{
        title: { String }
      },
      components:{ SvgIcon },
      data () {
        return {
          closed: true,
          isDAM: false,
          mdiCloudKeyOutlinePath: mdiCloudKeyOutline,
          mdiHexagonMultiplePath: mdiHexagonMultiple,
          mdiFolderMultiplePath: mdiFolderMultiple
        }
      },
      async created(){
        try {
          let response = await api.getApps(this.$API_URL, this.$ENV);
          let damCard = response.cards.filter(d=> d?.url=== "/portal/data-access-manager")[0];
          if (!damCard) {
            this.isDAM = false;
          } else {
            this.isDAM = true;
          }
        } catch (error) {
          console.log("error", error);
        } 
      },
      methods: {
      },
      watch:{

      }
    }
  </script>
  <style scoped>

    #app-side-bar{
        z-index:1000;
    }
  </style>
